import React from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Button, Search } from 'UI';
import { useBreadcrumbNavigation } from 'hooks/breadcrumb';
import { useRouteMatch } from 'react-router';

import {
  MainContainer,
  SearchContainer,
} from './style';

interface UserListExtraProps {
  onSearch(content: string): void
}

const SearchUserExtra = ({
  onSearch,
}: UserListExtraProps): JSX.Element => {
  const { url } = useRouteMatch();
  const breadcrumbNavigator = useBreadcrumbNavigation();

  return (
    <MainContainer>
      <SearchContainer>
        <Search placeholder="Buscar usuário" onSearch={onSearch} allowClear />
      </SearchContainer>
      <Button
        icon={<PlusOutlined size={14} />}
        onClick={() => breadcrumbNavigator.push({
          label: 'Cadastrar novo usuário',
          url: `${url}/Novo`,
        })}
      >
        Cadastrar novo usuário
      </Button>
    </MainContainer>
  );
};

export default SearchUserExtra;
